<template>
	<div :class="topHeightClass" :style="topHeightStyle" />
	<component :is="activeStickyComponent" v-if="activeStickyComponent" />
</template>

<script setup lang="ts">
import StickyHeader from '@/components/sticky-header/StickyHeader.vue'
import StickyHeaderAugustEv from '@/components/sticky-header/StickyHeaderAugustEv.vue'
import StickyHeaderQldRelocation from '@/components/sticky-header/StickyHeaderQldRelocation.vue'
import StickyHeaderSecurityNotice from '@/components/sticky-header/StickyHeaderSecurityNotice.vue'

const { isNovatedLeaseStickyActive } = showNovatedLeaseCampaign()
const { isSecondaryCampaignActive } = showStickyCampaign()
const { showAnnouncement } = useAnnouncementSchedule()
const { showSecurityNotice, securityNoticeSpacerStyle } = useSecurityNotice()

const topHeightClass = computed(() => {
	if (showSecurityNotice.value) return null
	if (
		showAnnouncement.value ||
		isSecondaryCampaignActive.value ||
		isNovatedLeaseStickyActive.value
	) {
		return 'h-32'
	}
	return 'h-20'
})

const topHeightStyle = computed(() => securityNoticeSpacerStyle.value)

const activeStickyComponent = computed(() => {
	if (showSecurityNotice.value) return StickyHeaderSecurityNotice
	if (showAnnouncement.value) return StickyHeaderQldRelocation
	if (isNovatedLeaseStickyActive.value) return StickyHeader
	if (isSecondaryCampaignActive.value) return StickyHeaderAugustEv
	return null
})
</script>
